import { BrowserRouter as Router } from "react-router-dom";
import AppRouter from "./routes/AppRouter";
import NavBar from "./components/NavBar";
import { useAppSelector } from "./hooks/useStore";
import "./App.css";

function App() {
  const isAuthenticated = useAppSelector(
    (state) => state.auth.isAuthenticated
  );

  return (
    <Router>
      {/* <Startup /> */}
      {isAuthenticated && <NavBar />}
      <AppRouter />
    </Router>
  );
}

export default App;
